import logo from '/logo-long.png';
import { Box, Grid, Typography } from '@mui/material';

export function AfterLowRatingSentPage(props: any) {
  return (
    <Box sx={{ p: 2 }}>
      <Grid container direction={'row'} spacing={2}>
        <Grid item xs={0} md={3} sm={2} />
        <Grid item xs={12} md={6} sm={8}>
          <Grid container direction={'column'} spacing={2}>
            <Grid item xs={12} sx={{ textAlign: 'center', maxWidth: '100% !important' }}>
              <Grid mt={2} mb={2}>
                <img src={logo} alt="足と歩行のクリニック：リジェ" style={{ margin: '0 auto' }} />
              </Grid>
              <Typography mb={2} pt={2} fontSize={'14px'}>
                貴重なご意見をいただき、
                <br />
                心より感謝申し上げます。
                <br />
                お会計まで今しばらくお待ちください。
              </Typography>
              <Typography mb={2} pt={2} fontSize={'14px'} color={'#A08B64'}>
                ※こちらのページは閉じてしまって
                <br />
                問題ございません。
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
